module.exports = __webpack_public_path__ + "img/arrow-up-right-white.85bb27ad.svg";